import React, { useState, useRef, useEffect } from "react";
import * as S from "./styles";
import ReactHtmlParser from "react-html-parser";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useMedia } from "use-media";

function Item({ item, last, first }) {
  const { image, title, description } = item;
  const [showTooltip, setShowToolip] = useState(false);
  const ref = useRef();
  const isMobile = useMedia({ maxWidth: 767 });

  const theme = createTheme({
    overrides: {
      MuiTooltip: {
        tooltip: {
          padding: isMobile ? "15px !important" : "15px",
          backgroundColor: "#fff",
          maxWidth: isMobile ? "350px" : "545px",
          borderRadius: "3.671px",
          background: "var(--Color-Surface-default, #fafafa)",
          boxShadow:
            "0px 0px 0.459px 0.459px rgba(0, 0, 0, 0.12), 0px 1.835px 5.506px 1.835px rgba(0, 0, 0, 0.25)",
        },
      },
    },
  });

  const tooltipText = {
    title:
      "A recarga automática é uma facilidade para você nunca ficar sem saldo!",
    description:
      "Você escolhe o valor para sua primeira recarga, a partir de R$50. Sempre que o saldo da conta chegar em 30%, nós recarregaremos automaticamente no cartão cadastrado. Você também pode acessar o app Veloe e realizar uma recarga adicional de forma manual apenas para compor saldo, se achar necessário.",
  };

  const text = "<span>Entenda o que é recarga automática{icon}</span>";

  const textWithIcon = (text) => {
    return text.replace(
      "{icon}",
      '<img src="/bradescoprime/assets/info_icon.svg" />'
    );
  };

  function handleTooltip() {
    setShowToolip(!showTooltip);
  }

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShowToolip(false);
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [showTooltip]);

  return (
    <S.Container>
      <S.Image>
        <img
          src={`https://${image.fields.file.url}`}
          alt={image.fields.title}
        />
      </S.Image>
      <S.Content>
        <S.Title color={"#230C87"}>{title}</S.Title>
        <S.Description color={"#230C87"}>{description}</S.Description>
      </S.Content>
      {last && (
        <S.LinkFooter
          href="https://veloe.com.br/onde-usar/mapa/"
          target="blank"
        >
          Ver cobertura
        </S.LinkFooter>
      )}
      {first && (
        <MuiThemeProvider theme={theme}>
          <Tooltip
            title={
              <div>
                <S.TooltipTitle>
                  <span>{tooltipText.title}</span>
                  <button onClick={() => setShowToolip(false)}>x</button>
                </S.TooltipTitle>
                <br />
                <S.TooltipDescription>
                  {tooltipText.description}
                </S.TooltipDescription>
              </div>
            }
            placement={"top"}
            interactive={true}
            open={showTooltip}
            ref={ref}
          >
            <S.TooltipLink onClick={handleTooltip}>
              {ReactHtmlParser(textWithIcon(text))}
            </S.TooltipLink>
          </Tooltip>
        </MuiThemeProvider>
      )}
    </S.Container>
  );
}

export default Item;
